import { isEmpty, uniq, upperFirst } from 'lodash-es';
import Form from 'components/form/Form';
import { bindMethod } from 'helpers/bind';
import { completeAddToCart, sendProductForm, setAddToCartLabel, startAddToCartLoading } from 'helpers/addToCartButton';
import { forceArray } from 'navigation/component/Component';
import PanelPage from 'navigation/pages/PanelPage';
import store from 'store';
export default class BundleSelectSize extends PanelPage {
    tab = 0;
    getModulesMap() {
        return {
            ...super.getModulesMap(),
            form: ['.bundle-select-size__form', Form]
        };
    }
    initialized() {
        super.initialized();
        forceArray(this.refs.productSizeRadios).forEach((radio) => {
            if (radio.checked)
                this.updateTabLabel(radio);
        });
        // open on the first tab still missing a size (setTab refreshes the add-to-cart label)
        const missing = this.missingField;
        this.setTab(missing ? this.fields.indexOf(missing) : 0);
    }
    resize() {
        super.resize();
        this.el.style.setProperty('--size-header-height', `${this.refs.selectSizeHeader.offsetHeight}px`);
        this.el.style.setProperty('--size-confirm-height', `${this.refs.selectSizeConfirm.offsetHeight}px`);
    }
    bindEvents(add) {
        super.bindEvents(add);
        const method = bindMethod(add);
        forceArray(this.refs.productSizeRadios).forEach((radio) => radio[method]('change', this.onRadioChange));
        forceArray(this.refs.sizeSwitchTab).forEach((tab) => tab?.[method]('click', this.onTabClick));
        this.refs.addToCart?.[method]('click', this.onAddToCart);
    }
    // fields in tab order: 'article' then 'article_2'
    get fields() {
        return uniq(forceArray(this.refs.productSizeRadios).map((radio) => radio.dataset.field));
    }
    onRadioChange = (e) => {
        const radio = e.currentTarget;
        this.updateTabLabel(radio);
        const detail = { [radio.dataset.field]: radio.value, label: radio.dataset.label };
        window.dispatchEvent(new CustomEvent('bundle:update-size', { detail }));
        this.updateAddToCartLabel();
    };
    onTabClick = (e) => {
        this.setTab(this.refs.sizeSwitchTab.indexOf(e.currentTarget));
    };
    setTab(index) {
        forceArray(this.refs.sizeSwitchTab).forEach((tab, i) => tab?.classList.toggle('active', index === i));
        this.refs.sizeTabs.dataset.active = index.toString();
        this.tab = index;
        this.updateAddToCartLabel();
    }
    updateTabLabel(radio) {
        const label = forceArray(this.refs.sizeTabLabels).find((l) => l?.dataset.inputName === radio.dataset.field);
        if (label)
            label.textContent = radio.dataset.label;
    }
    // the field the user should fill next: the current tab first, then the other one
    get missingField() {
        const values = this.modules.form.getFormValues();
        const fields = this.fields;
        const current = fields[this.tab];
        return [current, ...fields.filter((f) => f !== current)].find((f) => isEmpty(values[f]));
    }
    updateAddToCartLabel() {
        const btn = this.refs.addToCart;
        if (!btn)
            return;
        const missing = this.missingField;
        setAddToCartLabel(btn, missing ? btn.dataset[`invalid${upperFirst(missing)}`] : btn.dataset.text);
    }
    onAddToCart = async (e) => {
        const form = this.modules.form;
        form.setSubmitted(false);
        if (!(await form.quickValid())) {
            const missing = this.missingField;
            if (missing)
                this.setTab(this.fields.indexOf(missing));
            return;
        }
        const btns = [this.refs.addToCart];
        await startAddToCartLoading(btns);
        sendProductForm({
            form,
            submitter: e.currentTarget,
            callback: ({ data }) => {
                completeAddToCart(btns, data.error !== null);
                setTimeout(() => store.panel.set(null), 500);
            }
        });
    };
}
